import React from 'react'
import formatMessage from 'format-message'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import SecondaryToolbarButton from '../SecondaryToolbarButton'

const buttonSvgs = {
  Small: (
    <svg width={18} height={18}>
      <path
        d="M2.207 17.207L.793 15.793 16.639-.054l1.415 1.415z"
        fill="#384A58"
        fillRule="nonzero"
      />
    </svg>
  ),
  Medium: (
    <svg width={19} height={19}>
      <path
        d="M2.914 18.914L.086 16.086 15.932.239l2.829 2.829z"
        fill="#384A58"
        fillRule="nonzero"
      />
    </svg>
  ),
  Large: (
    <svg width={21} height={21}>
      <path
        d="M4.975 20.975l-4.95-4.95L15.872.18l4.95 4.95z"
        fill="#384A58"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default function InkStrokeWidthButton({
  isSelected,
  onCurrentInkStrokeWidthChange,
  sizeValue,
  width
}) {
  const handleClick = _event => {
    if (!isSelected && typeof onCurrentInkStrokeWidthChange === 'function') {
      onCurrentInkStrokeWidthChange(width)
    }
  }
  const strokeWidth = sizeValue ? formatMessage(sizeValue) : undefined
  const ariaLabel = formatMessage('Annotation stroke width {strokeWidth}', {
    strokeWidth
  })
  const className = classnames('InkStrokeWidthButton', {
    selected: isSelected
  })

  return (
    <SecondaryToolbarButton
      title={strokeWidth}
      ariaLabel={ariaLabel}
      onClick={handleClick}
      className={className}
    >
      {button => (
        <div className="InkStrokeWidthButton-outer">
          {buttonSvgs[strokeWidth]}
        </div>
      )}
    </SecondaryToolbarButton>
  )
}
